import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import { ActionInterface } from "../../Interface/ActionInterface";
import Http from "../../Http/Http";

export default function* attachmentDelete(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_ATTACHMENT_DELETE_REQUEST
    });

    const res = yield call(Http.delete, `attachment/${action.payload?.id}`);
    if (action.payload?.entity) {
      const entity = action.payload?.entity.reinitialize({
        attachments: action.payload?.attachments
          .filter(attachment => attachment.id !== action.payload?.id)
          .map(attachment => attachment.data)
      });

      switch (action.payload?.entityType) {
        case "contactId":
          yield put({
            type: Constants.GLOBAL_ATTACHMENT_PERSON_DELETE_SUCCESS,
            payload: {
              person: entity
            }
          });
          break;

        case "companyId":
          yield put({
            type: Constants.GLOBAL_ATTACHMENT_COMPANY_DELETE_SUCCESS,
            payload: {
              company: entity
            }
          });

          break;

        case "agencyId":
          yield put({
            type: Constants.GLOBAL_ATTACHMENT_AGENCY_DELETE_SUCCESS,
            payload: {
              agency: entity
            }
          });

          yield put({
            type: Constants.GLOBAL_ATTACHMENT_COMPANY_DELETE_SUCCESS,
            payload: {
              company: entity
            }
          });
          break;

        case "propertyId":
          yield put({
            type: Constants.GLOBAL_ATTACHMENT_PROPERTY_DELETE_SUCCESS,
            payload: {
              property: entity
            }
          });
          break;

        case "unitId":
          yield put({
            type: Constants.GLOBAL_ATTACHMENT_UNIT_DELETE_SUCCESS,
            payload: {
              unit: entity
            }
          });
          break;

        case "contractId":
          yield put({
            type: Constants.GLOBAL_ATTACHMENT_CONTRACT_DELETE_SUCCESS,
            payload: {
              contract: entity
            }
          });
          break;

        case "taskId":
          yield put({
            type: Constants.GLOBAL_ATTACHMENT_TASK_DELETE_SUCCESS,
            payload: {
              task: entity
            }
          });
          break;

        case "chargeId":
          yield put({
            type: Constants.GLOBAL_ATTACHMENT_CHARGE_DELETE_SUCCESS,
            payload: {
              charge: entity
            }
          });
          break;

        case "eventId":
          yield put({
            type: Constants.GLOBAL_ATTACHMENT_EVENT_DELETE_SUCCESS,
            payload: {
              event: entity
            }
          });
          break;

        case "conversationId":
          yield put({
            type: Constants.GLOBAL_ATTACHMENT_CONVERSATION_DELETE_SUCCESS,
            payload: {
              conversation: entity
            }
          });
          break;

        default:
          return;
      }
    }

    if (action.hasOwnProperty("onSuccess")) {
      action.onSuccess.call(this, res?.data?.id);
    }

  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_ATTACHMENT_DELETE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchAttachmentDelete() {
  yield takeEvery(Constants.GLOBAL_ATTACHMENT_DELETE_START, attachmentDelete);
}
